import { render, staticRenderFns } from "./DormitoryPaymentPanel.vue?vue&type=template&id=fe99cfd2&scoped=true"
import script from "./DormitoryPaymentPanel.vue?vue&type=script&lang=js"
export * from "./DormitoryPaymentPanel.vue?vue&type=script&lang=js"
import style0 from "./DormitoryPaymentPanel.vue?vue&type=style&index=0&id=fe99cfd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe99cfd2",
  null
  
)

export default component.exports